module.exports = __webpack_public_path__ + "static/media/2020_4.1046ced4.jpg";